import gql from 'graphql-tag';

export default gql`
  query emailAddressAutocomplete(
    $q: String!
  ) {
    emailAddressAutocomplete(
      q: $q
    )
  }
`;
